import React from 'react';
import { call, put } from 'redux-saga/effects';
import { execute } from 'store/configureStore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Table, TableRow, TableHeaderColumn, TableHeader, TableBody, TableRowColumn, FlatButton, RaisedButton } from 'material-ui';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import Dialog from 'material-ui/Dialog';
import EditDialog from './EditDialog';

import { deleteReqRates } from 'actions/reqldRates/reqRates';
import { getCargoTypes } from 'actions/cargoes/types';
import { showNotification } from 'helpers';

import * as actionTypes from 'constants/ActionTypes';

import api from 'services';

const defaultStyles = { 
    textAlign: 'center',
    padding: 0,
};

const styles = {
    longText: {
        ...defaultStyles,
        width: '120px',
    },
    middleText: {
        ...defaultStyles,
        width: '80px',
    },
    smallText: {
        ...defaultStyles,
        width: '65px',
    },

};

const initialRateEditAddState = {
    _id: '',
    cargoName: '',
    cargoTypeName: '',
    type: '',
    cargoWeight: '',
    cargoVolume: '',
    port: {},
    country: {},
    rate: {},
}; 

const initialRateDeleteState = {
    _id: '',
};

class ReqLDRatesTable extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            openEditDialog: false,
            openDeleteDialog: false,
            rateEditAdd: Object.assign({}, initialRateEditAddState),
            rateDelete: Object.assign({}, initialRateDeleteState),
            ports: [],
            cargoes: [],
        };
    }

    componentDidMount() {
        this.props.getCargoTypes();
    }

    handleOpenEdit = ({
        _id, cargoName, cargoTypeName, type, cargoWeight, cargoVolume, port, country, rate, 
    }) => {
        this.setState({
            rateEditAdd: {
                _id, cargoName, cargoTypeName, type, cargoWeight, cargoVolume, port, country, rate,
            },
            openEditDialog: true,
        });
    }

    handleOpenDelete = (_id) => {
        this.setState({
            rateDelete: { _id },
            openDeleteDialog: true,
        });
    }

    handleRateDelete = async () => {
        await execute(this.deleteRate, this.state.rateDelete._id);
    
        this.setState({
            openDeleteDialog: false,
            rateDelete: Object.assign({}, initialRateDeleteState),
        });
        
        await execute(this.props.loadRates, this.props.pagination);
    };

    * deleteRate(_id) {
        const response = yield call(api.deleteReqLDRate, _id);

        if (response.status === 200) {
            showNotification(response.data.message, 'success');
        }

        yield put({
            type: actionTypes.GET_REQ_LD_RATES,
            data: response,
        });
    }

    handleCloseDialog = (type) => {
        let fields = {};

        switch (type) {
        case 'edit':
            fields = {
                dialog: 'openEditDialog',
                init: Object.assign({}, initialRateEditAddState),
                state: 'rateEditAdd',
            };
            break;
        case 'delete': 
            fields = {
                dialog: 'openDeleteDialog',
                init: Object.assign({}, initialRateDeleteState),
                state: 'rateDelete',
            };
            break;
        case 'add':
            this.props.handleOpenAddDialog();
            this.setState({
                rateEditAdd: Object.assign({}, initialRateEditAddState),
            });
            return;
        }
        
        this.setState({
            [fields.dialog]: false,
            [fields.state]: fields.init,
        });
    }

    updateEditAddState = (type, data, cb) => {
        if (!data.hasOwnProperty('value')) {
            this.setState({
                rateEditAdd: {
                    ...this.state.rateEditAdd,
                    [type]: data,
                },
            }, cb);
        } else {
            this.setState({
                rateEditAdd: {
                    ...this.state.rateEditAdd,
                    rate: {
                        ...this.state.rateEditAdd.rate,
                        [type]: data.value,
                    },
                },
            }, cb);
        }
    }

    handleRateEditAdd = async (type) => {
        const {
            cargoName, cargoTypeName, cargoVolume, cargoWeight, country, port, rate: { quantity, dimension }, 
        } = this.state.rateEditAdd; 

        if (!cargoName || !cargoTypeName || !(parseInt(cargoVolume) || parseInt(cargoWeight)) || !country._id || !port._id || !parseInt(quantity) || !dimension) {
            showNotification('Specify all required fields', 'error');
            return;
        }

        let response;
        if (type === 'edit') {
            response = await execute(this.editRate, this.state.rateEditAdd);
        } else {
            response = await execute(this.addRate, this.state.rateEditAdd);
        }

        if (!response) {
            return;
        }
    
        this.setState({
            openEditDialog: false,
            rateEditAdd: Object.assign({}, initialRateEditAddState),
        });
        
        if (type === 'add') {
            await this.props.handleOpenAddDialog();
        }
        await execute(this.props.loadRates, this.props.pagination);
    };

    * editRate(data) {
        const response = yield call(api.editReqLDRate, data);

        if (response.status === 200) {
            showNotification(response.data.message, 'success');
        } else {
            showNotification(response.errors[0].message, 'error');
            return false;
        }

        yield put({
            type: actionTypes.EDIT_REQ_LD_RATES,
            data: response,
        });

        return true;
    }

    * addRate(data) {
        const response = yield call(api.addReqLDRate, data);

        if (response && response.status === 200) {
            showNotification(response.data.message, 'success');
        } else {
            showNotification(response.errors[0].message, 'error');
            return false;
        }

        yield put({
            type: actionTypes.EDIT_REQ_LD_RATES,
            data: response,
        });

        return true;
    }

    handleSelectCountry = (e, i) => {
        e.preventDefault();
        if (i === 0) {
            this.updateEditAddState('country', { name: '', _id: '' });
            return;
        }

        const { _id, name } = this.props.countries[i];

        this.updateEditAddState('country', { name, _id });
    }

    changePortAutoCompete = (searchPort) => {
        this.updateEditAddState('port', { name: searchPort, _id: '' }, () => {
            const { name } = this.state.rateEditAdd.port;
            
            if (name.length < 2) {
                return;
            }
    
            api.findPortAdmin({ name })
                .then((response) => {
                    if (response.status === 200) {
                        const ports = response.data.data.map(port => ({
                            name: port.country ? `${port.name}, ${port.country.name}` : port.name,
                            _id: port._id,
                        }));
    
                        this.setState({
                            ports,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error AutoComplete ports - port of registry', error);
    
                    return null;
                });
        });
    }

    choosePortAutoComplete = ({ name, _id }) => {
        this.updateEditAddState('port', { name: name.split(',')[0], _id });
    }

    changeCargoAutoCompete = (searchCargo) => {
        this.updateEditAddState('cargoName', searchCargo, () => {
            const { cargoName } = this.state.rateEditAdd;
            
            if (cargoName.length < 2) {
                return;
            }
            
            api.getCargoNamesAutocomplete(cargoName)
                .then((response) => {
                    if (response.status === 200) {
                        const cargoes = response.data.data.map(cargo => ({
                            name: cargo.name,
                            _id: cargo._id,
                        }));

                        this.setState({
                            cargoes,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error AutoComplete cargoes - cargo of registry', error);

                    return null;
                });
        });
    }

    chooseCargoAutoComplete = ({ name }) => {
        this.updateEditAddState('cargoName', name);
    }

    render() {
        const { rates, countries } = this.props;
        if (!rates) {
            return null;
        } 

        const {
            openEditDialog, openDeleteDialog, rateEditAdd, ports, cargoes, 
        } = this.state;
        const { openAddDialog, cargoTypes } = this.props;

        const deleteActions = [
            <FlatButton
                label="Cancel"
                primary
                onClick={() => this.handleCloseDialog('delete')}
            />,
            <FlatButton
                label="Submit"
                primary
                keyboardFocused
                onClick={this.handleRateDelete}
            />,
        ];

        return (
            <div>
                <EditDialog 
                    openEditDialog={openEditDialog}
                    openAddDialog={openAddDialog}
                    handleCloseDialog={this.handleCloseDialog}
                    handleSelectCountry={this.handleSelectCountry}
                    rateEditAdd={rateEditAdd}
                    countries={countries}
                    ports={ports}
                    cargoes={cargoes}
                    changePortAutoCompete={this.changePortAutoCompete}
                    choosePortAutoComplete={this.choosePortAutoComplete}
                    changeCargoAutoCompete={this.changeCargoAutoCompete}
                    chooseCargoAutoComplete={this.chooseCargoAutoComplete}
                    updateRate={this.updateEditAddState}
                    handleRateEditAdd={this.handleRateEditAdd}
                    cargoTypes={cargoTypes}
                />
                    
                <Dialog
                    title='Delete rate'
                    open={openDeleteDialog}
                    actions={deleteActions}
                    onRequestClose={() => this.handleCloseDialog('delete')}
                >
                    Are you sure you want to delete l/d rate?
                </Dialog>

                <Table>
                    <TableHeader
                        displaySelectAll={false}
                        enableSelectAll={false}
                        adjustForCheckbox={false}
                    >
                        <TableRow>
                            <TableHeaderColumn style={styles.longText}>Name</TableHeaderColumn>
                            <TableHeaderColumn style={styles.longText}>Type</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>Weight</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>Volume</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>Quantity</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>Dimension</TableHeaderColumn>
                            <TableHeaderColumn style={styles.longText}>Speed</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>Abbr</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>Term</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>L/D</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>Port</TableHeaderColumn>
                            <TableHeaderColumn style={styles.middleText}>Country</TableHeaderColumn>
                            <TableHeaderColumn style={{ width: '40px' }} />
                        </TableRow>
                    </TableHeader>
                    <TableBody
                        displayRowCheckbox={false}
                    >
                        {
                            rates.map(item => (
                                <TableRow
                                    key={item._id}
                                    displayBorder
                                    selectable={false}
                                    hoverable
                                >
                                    <TableRowColumn style={{ ...styles.longText, textAlign: 'start', whiteSpace: 'initial' }}>{item.cargoName}</TableRowColumn>
                                    <TableRowColumn style={{ ...styles.longText, textAlign: 'start', whiteSpace: 'initial' }}>{item.cargoTypeName}</TableRowColumn>
                                    <TableRowColumn style={{ ...styles.smallText, padding: 0 }}>{item.cargoWeight || '-'}</TableRowColumn>
                                    <TableRowColumn style={styles.smallText}>{item.cargoVolume || '-'}</TableRowColumn>
                                    <TableRowColumn style={styles.smallText}>{item.rate.quantity}</TableRowColumn>
                                    <TableRowColumn style={styles.smallText}>{item.rate.dimension || '-'}</TableRowColumn>
                                    <TableRowColumn style={{ ...styles.longText, whiteSpace: 'initial' }}>{item.rate.speed || '-'}</TableRowColumn>
                                    <TableRowColumn style={styles.smallText}>{item.rate.abbreviation || '-'}</TableRowColumn>
                                    <TableRowColumn style={styles.smallText}>{item.rate.term || '-'}</TableRowColumn>
                                    <TableRowColumn style={styles.smallText}>{item.type === 'loading' ? 'L' : 'D'}</TableRowColumn>
                                    <TableRowColumn style={styles.smallText}>{item.port.name}</TableRowColumn>
                                    <TableRowColumn style={styles.middleText}>{item.country.name}</TableRowColumn>
                                    <TableRowColumn
                                        style={{ width: '40px', padding: 0 }}
                                    >
                                        <EditIcon
                                            cursor='pointer'
                                            color='#09BCD4'
                                            onClick={() => this.handleOpenEdit(item)}
                                        />
                                        <DeleteIcon
                                            cursor='pointer'
                                            color='#FF4081'
                                            onClick={() => this.handleOpenDelete(item._id)}
                                        />
                                    </TableRowColumn>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default connect(
    state => ({
        cargoTypes: state.cargoTypes,
    }),
    dispatch => bindActionCreators(
        {
            deleteReqRates,
            getCargoTypes,
        },
        dispatch,
    ),
)(ReqLDRatesTable);



// WEBPACK FOOTER //
// ./app/components/Cargoes/RequestsLDRates/ReqLDRatesTable.jsx